import { Role } from '../model/users'
import { getIntersessionInStore } from './intersession'

export const getUserDashboard = (
	userRole: Role,
	storeId?: string,
	teloEnabled: boolean = true,
	renewalPrescriptionEnabled: boolean = false,
) => {
	const inStore = getIntersessionInStore()
	const doctorUrl = teloEnabled
		? inStore
			? `/store/${storeId}/worklist`
			: '/doctor/worklist'
		: renewalPrescriptionEnabled
		? '/doctor/renewal/dashboard'
		: '/grants'

	const rolesAndRedirect: { role: Role; redirect: string }[] = [
		{ role: 'Doctor', redirect: doctorUrl },
		{ role: 'Refractionist', redirect: `/refractionist/dashboard` },
		{ role: 'Technician', redirect: `/store/${storeId}/worklist` },
		{ role: 'FrontDesk', redirect: `/store/${storeId}/worklist` },
		{ role: 'GlobalAdmin', redirect: `/store/${storeId}/worklist` },
		{ role: 'TechnicalAdmin', redirect: `/store/${storeId}/worklist` },
	]

	const pointer = rolesAndRedirect.find(rnr => userRole === rnr.role)

	return pointer?.redirect || `/store/${storeId}/worklist`
}
